export const isSameOrderIndex = (
	prev: Map<string, number>,
	next: Map<string, number>,
	order: readonly string[],
): boolean => {
	if (prev.size !== next.size) {
		return false;
	}
	for (const key of order) {
		if (prev.get(key) !== next.get(key)) {
			return false;
		}
	}
	return true;
};
